import { useEffect, useState } from 'react';

import StarIcon from './icons/StarIcon';
import Alston from '../../../Markup/assets/img/alston.jpeg';
import Danial from '../../../Markup/assets/img/danial.jpeg';
import Msmarkita from '../../../Markup/assets/img/Msmarkita.jpeg';
import Rafal from '../../../Markup/assets/img/Rafal.jpeg';

const reviews = [
	{
		name: 'Alston',
		details:
			'Great Add-on (Super Support & Backed Up by Speed Tests). This tool will help our web design business.It is such a great product because elementor is excellent but this addon offers a lot more features and functions.',
		image: Alston,
	},
	{
		name: 'Daniel',
		details:
			'This plugin ticks all the boxes. It’s effective in driving conversions. It’s slick and well designed. It’s so easy to edit and use. LOVE THIS PLUGIN.',
		image: Danial,
	},
	{
		name: 'Msmarkita',
		details:
			'Love This Platform. Love how user-friendly this site is as well as they have excellent customer service!',
		image: Msmarkita,
	},
	{
		name: 'Rafal',
		details:
			'Great support. Love plugin but even more I love its support 🙂 Great job!  I had problem with displaying post in Instant Answer widget – solved of course 🙂 ',
		image: Rafal,
	},
];

export function Testimonials() {
	const [selected, setSelected] = useState({
		name: '',
		details: '',
		image: '',
	});

	useEffect(() => {
		const random = Math.floor(Math.random() * reviews.length);
		setSelected(reviews[random]);
	}, []);

	return (
		<>
			<div className="wp-checkout-testimonials-section">
				<ul className="wp-checkout-star-ratingn">
					<li className="wp-checkout-star">
						<StarIcon />
					</li>
					<li className="wp-checkout-star">
						<StarIcon />
					</li>
					<li className="wp-checkout-star">
						<StarIcon />
					</li>
					<li className="wp-checkout-star">
						<StarIcon />
					</li>
					<li className="wp-checkout-star">
						<StarIcon />
					</li>
				</ul>
				<p className="wp-checkout-font-base wp-checkout-testimonial-content">
					{selected.details}
				</p>
				<div className="wp-checkout-customer-information">
					<div className="customer-img">
						<img
							src={selected.image}
							alt={selected.name}
						/>
					</div>
					<a
						rel="nofollow"
						href="#"
						className="wp-checkout-font-lg  customer-mail"
					>
						{selected.name}
					</a>
				</div>
			</div>
		</>
	);
}
